exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".Components__button___q261i {\n  border: 6px;\n  fill: #FE6768;\n  stroke-width: 6px;\n  stroke: #F15F64;\n  cursor: pointer; }\n  .Components__button___q261i:hover {\n    fill: #F15F64; }\n\n.Components__buttonOutline___3RShZ {\n  stroke-width: 8px;\n  fill: #f93b3b;\n  stroke: #F15F64; }\n\n.Components__buttonArrow___ZQ2GY {\n  fill: #fff;\n  stroke-width: 0px; }\n\n.Components__buttonArrowOutline___3hfi7 {\n  stroke: #F15F64;\n  fill: #F15F64;\n  stroke-width: 2px; }\n\n.Components__link___44LNJ {\n  cursor: pointer;\n  fill: #fe6768; }\n  .Components__link___44LNJ:hover {\n    fill: #f15f64; }\n\n.Components__linkActive___3He__ {\n  fill: #77b9db; }\n\n.Components__arrowRotate___19_bj {\n  -webkit-transform: translate(30px);\n      -ms-transform: translate(30px);\n          transform: translate(30px);\n  -webkit-transform: rotate(45deg);\n      -ms-transform: rotate(45deg);\n          transform: rotate(45deg); }\n", ""]);

// exports
exports.locals = {
	"button": "Components__button___q261i",
	"buttonOutline": "Components__buttonOutline___3RShZ",
	"buttonArrow": "Components__buttonArrow___ZQ2GY",
	"buttonArrowOutline": "Components__buttonArrowOutline___3hfi7",
	"link": "Components__link___44LNJ",
	"linkActive": "Components__linkActive___3He__",
	"arrowRotate": "Components__arrowRotate___19_bj"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1,"modules":true,"localIdentName":"[name]__[local]___[hash:base64:5]"}!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./node_modules/sass-loader/lib/loader.js!./src/styles/Components.scss
// module id = 172
// module chunks = 0